/**
 * Created by jacmai on 6/26/2017.
 */
define(["marionette", "./template/variablePromptsListTemplate.html"], function (
  Marionette,
  VariablePromptsListTemplate,
) {
  var VariablePromptsListView = {};

  VariablePromptsListView.variablePromptsList = Marionette.Layout.extend({
    template: VariablePromptsListTemplate,
    regions: {
      list: "#list",
    },
  });

  return VariablePromptsListView;
});
